import React, { useState } from 'react'
import { useRouter } from '~/hooks/useRouter'
import styles from './BookVisit.module.css'
import { CustomButton } from '~/components/CustomButton/CustomButton'
import { Modal } from '~/components/Modal/Modal'
import { FormattedMessage, useIntl } from 'react-intl'
import axios from 'axios'

export const BookVisitPage: React.FC = () => {
  const intl = useIntl()
  const router = useRouter()

  // form values
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')

  // validation errors
  const [errors, setErrors] = useState({
    name: '',
    email: '',
    message: '',
  })

  // modal state
  const [messageSent, setMessageSent] = useState(false)

  const handleSubmit = async () => {
    // reset errors
    const newErrors = { name: '', email: '', message: '' }

    if (!name.trim()) {
      newErrors.name = intl.formatMessage({
        id: 'checkout.error.required',
        defaultMessage: 'Acest câmp este obligatoriu',
      })
    }
    if (!email.trim()) {
      newErrors.email = intl.formatMessage({
        id: 'checkout.error.required',
        defaultMessage: 'Acest câmp este obligatoriu',
      })
    }
    if (!phone.trim()) {
      newErrors.message = intl.formatMessage({
        id: 'checkout.error.required',
        defaultMessage: 'Acest câmp este obligatoriu',
      })
    }

    setErrors(newErrors)
    if (Object.values(newErrors).some((msg) => msg)) {
      return
    }

    // send the message
    await axios.post('/api/contact-form', {
      text: `<b>New Visit Request!!!</b>
             <b>Name:</b> ${name}
             <b>Email:</b> ${email}
             <b>Phone:</b> ${phone}
             <b>Address:</b> ${address}`,
    })

    setMessageSent(true)
    // clear fields
    setName('')
    setEmail('')
    setPhone('')
    setAddress('')
  }

  const handleCloseModal = () => {
    setMessageSent(false)
    router.push('/')
  }

  return (
    <div>
      {/* Hero Section */}
      <section className={styles.pageHero}>
        <div className={styles.container}>
          <h1 className={styles.title}>
            <FormattedMessage id="contacts.bookVisit.title" />
          </h1>
          <h2 className={styles.subtitle}>
            <FormattedMessage id="contacts.bookVisit.subtitle" />
          </h2>
        </div>
      </section>

      {/* Main Content */}
      <main className={styles.contactSection}>
        <div className={styles.container}>
          <div className={styles.contactColumns}>
            {/* Contact Form */}
            <div className={styles.contactFormWrapper}>
              <form
                onSubmit={(e) => e.preventDefault()}
                className={styles.contactForm}
              >
                <div className={styles.formGroup}>
                  <label htmlFor="nume">
                    <FormattedMessage id="contacts.nameSurname" />
                  </label>
                  <input
                    type="text"
                    id="nume"
                    name="nume"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value)
                      setErrors((e) => ({ ...e, name: '' }))
                    }}
                    placeholder={intl.formatMessage({
                      id: 'contacts.nameSurname.placeholder',
                    })}
                    data-testid="contact-name"
                  />
                  {errors.name && <p className={styles.error}>{errors.name}</p>}
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email">
                    <FormattedMessage id="contacts.email" />
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value)
                      setErrors((e) => ({ ...e, email: '' }))
                    }}
                    placeholder={intl.formatMessage({
                      id: 'contacts.email.placeholder',
                    })}
                    data-testid="contact-email"
                  />
                  {errors.email && (
                    <p className={styles.error}>{errors.email}</p>
                  )}
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="telefon">
                    <FormattedMessage id="contacts.phoneNumber" />
                  </label>
                  <input
                    type="tel"
                    id="telefon"
                    name="telefon"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder={intl.formatMessage({
                      id: 'contacts.phoneNumber.placeholder',
                    })}
                    data-testid="contact-phone"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="address">
                    <FormattedMessage id="contacts.address" />
                  </label>
                  <textarea
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => {
                      setAddress(e.target.value)
                      setErrors((e) => ({ ...e, message: '' }))
                    }}
                    placeholder={intl.formatMessage({
                      id: 'contacts.address.placeholder',
                    })}
                  />
                  {errors.message && (
                    <p className={styles.error}>{errors.message}</p>
                  )}
                </div>

                <div className={styles.buttonContainer}>
                  <CustomButton onClick={handleSubmit} data-testid="contact-submit">
                    <FormattedMessage id="contacts.button.sendRequest" />
                  </CustomButton>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      {/* Thank You Modal */}
      <Modal isOpen={messageSent} onClose={handleCloseModal}>
        <h3 data-testid="contact-thankyou">
          <FormattedMessage id="contacts.bookVisit.modal.thankYouMessage" />
        </h3>
      </Modal>
    </div>
  )
}
